import { $ } from 'utils/dom';
import Shower from 'modules/shower';

class TogglePageHeaderSearch {
  constructor(params) {
    this.header = params.header;
    this.inputShower = null;
    this.inputShowerInitiated = false;
  }

  initInputShower = () => {
    this.inputShower = new Shower({
      target: $('.page-header__search-input', this.header),
      handler: $('.page-header__search > button', this.header),
      easing: 'easeInOutCubic',
      duration: 200,
      openClassName: 'is-active',
      toggleStart: el => {
        this.header.classList.toggle('page-header--margin');
      },
    });

    if (!this.inputShowerInitiated) {
      this.inputShower.init();
      this.inputShowerInitiated = true;
    }
  };

  moveFocusToInput = () => {
    const searchBtn = $('.btn--plusminus', this.header);
    const input = $('.page-header__search-input input', this.header);
    searchBtn.addEventListener('click', function () {
      input.focus();
    });
  };

  init = () => {
    this.initInputShower();
    this.moveFocusToInput();
  };
}

const pageHeader = $('.page-header--overview');
const pageHeaderSearch = $('.page-header__search');

if (pageHeader && pageHeaderSearch) {
  new TogglePageHeaderSearch({
    header: pageHeader,
  }).init();
}
